import React from 'react';
import { motion } from 'framer-motion';

export const Section = ({ children, className = '', id, bg = 'bg-vintage-white' }) => {
  return (
    <section 
      id={id} 
      className={`py-12 md:py-20 lg:py-24 ${bg} ${className}`}
    >
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="max-w-[1320px] mx-auto px-5 md:px-10 lg:px-12"
      >
        {children}
      </motion.div>
    </section>
  );
};

export const SectionHeader = ({ title, subtitle, className = '' }) => (
  <div className={`text-center max-w-3xl mx-auto mb-10 md:mb-16 ${className}`}>
    <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-deep-charcoal mb-4 leading-tight">
      {title}
    </h2>
    {subtitle && (
      <p className="text-base md:text-lg lg:text-xl text-deep-charcoal/70 font-light leading-relaxed">
        {subtitle}
      </p>
    )}
    <div className="w-12 h-px bg-estate-bronze mx-auto mt-6 opacity-40"></div>
  </div>
);